import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "@vue/reactivity";



export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingSpinner',
  props: {
  value: {
    type: Boolean,
  },
  message: {
    type: String || null,
    required: false,
    default: null,
  },
},
  emits: ["input"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const showDialogHandler = computed({
  get() {
    return props.value;
  },
  set(value) {
    emit("input", value);
  },
});

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    absolute: true,
    width: "auto",
    persistent: true,
    modelValue: _unref(showDialogHandler),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(showDialogHandler) ? (showDialogHandler).value = $event : null))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_progress_circular, {
        size: "70",
        width: 7,
        color: "primary",
        indeterminate: ""
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})